import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MapAssetAndDevicesJS from "components/maps/MapAssetAndDevicesJS";
import ConditionalRender from "../../../components/ConditionalRender";

const PrevAssetDevice = ({ item, showPreview, deviceStatus }) => {
    const { t: _Tt } = useTranslation("tables");
    const { t: _Tc } = useTranslation("choices");
    return (
        <div className={`col preview-row ${showPreview ? "" : "d-none"}`} style={{ width: "300px", maxWidth: "300px" }}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{ width: "300px" }}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon="network-wired" />
                            </div>
                            <div className="preview-title">
                                <label>IMEI</label>
                                <div>{item.uuid}</div>
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{_Tt("devices.status")}</label>
                            <div className="preview-input">{deviceStatus[item.status]}</div>
                        </div>
                        <div className="preview-item">
                            <label>{_Tt("devices.note")}</label>
                            <div className="preview-input">{item.note}</div>
                        </div>
                        <div className="preview-item">
                            <label>{_Tt("devices.Alarm")}</label>
                            <div className="preview-input">
                                {item.device_alerts.map((alert) => (
                                    <div key={alert.id}>{_Tc("alerts_types." + alert.type)}</div>
                                ))}
                            </div>
                        </div>
                        <MapAssetAndDevicesJS
                            asset={{}}
                            devices={[item]}
                            mapId={`map-preview-${item.id || item.uuid}`}
                            height="120px"
                            zoom={13}
                            show={showPreview}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevAssetDevice;
